/* eslint-disable arrow-body-style */
import React, { useEffect } from 'react';
import {
  Icon, sanitize,
} from '@honeycomb-npm/honeycomb-react';
import { content } from '../../../utils/contentUtils';
import { analyticsConstants } from '../../../constants/analyticsConstants';

const SuccessPage = () => {
  useEffect(() => {
    document.getElementById(analyticsConstants.ofiSuccess)?.click();
  }, []);
  return (
    <div
      className="col-lg-8 col-sm-12 blade blade--vertical px-4"
    >
      <span id={analyticsConstants.ofiSuccess} />
      <div className="blade__content mt-8">
        <div className="d-flex">
          <Icon
            screenreader="Success icon"
            symbol="messageSuccess64"
            type="svgfile"
          />
          <div className="ml-2">
            <h2
              className="mt-1"
              dangerouslySetInnerHTML={sanitize(content.success.successTitle)}
            />
            <div dangerouslySetInnerHTML={sanitize(content.success.successDescription)} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
